import { useField, FieldHookConfig } from 'formik';
import { HintIcon } from '../../HintIcon';
import styles from './DropdownInput.module.scss';

interface OwnProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  defaultValue?: string;
  hintIcon?: boolean;
  hintText?: string;
}

const DropdownInput = ({ label, hintIcon, hintText, ...props }: OwnProps & FieldHookConfig<string>): JSX.Element => {
  const [field, meta] = useField(props);
  return (
    <div className={styles.container}>
      <div className={styles.labelHint}>
        {label && (
          <label className={styles.label} htmlFor={props.id || props.name}>
            {label}
          </label>
        )}
        {hintIcon && <HintIcon style={{ margin: '-0.7rem 0.8rem -1rem' }} hintText={hintText} />}
      </div>
      <select {...props} {...field} />
      <div className={styles.errorHint}>{meta.touched && meta.error ? meta.error : null}</div>
    </div>
  );
};

export default DropdownInput;
